Revolution.Module.extend({
    NAME: "mde.sliders", // OBLIGATOIRE (reflète l'arborescence répertoire : /mde/main.js)
    gridToSliderIsInit : false,
    gridToSliderList : [],
    sliderNumbersIsInit : false,
    sliderNumbersList : [],

    initialize: function ($) {
        // appelé aussitôt la page chargée
        //console.log("module " + this.NAME);

        _.bindAll(this, "sliderWysiwyg", "initGridToSlider", "initOrDestroyGridToSlider");

        //events

        this.initSliders();
        this.sliderHeading();
        this.sliderWysiwyg();
        this.sliderTimeline();
        this.sliderPersonalities();
        this.sliderDocs();

        this.initOrDestroyGridToSlider();
        this.initOrDestroySliderNumbers();
    },

    onWindowLoad: function (e) {
        this.updateSliders();
    },

    onWindowScroll: function (e) {

    },
    onWindowResize: function (e) {
        this.initOrDestroyGridToSlider();
        this.initOrDestroySliderNumbers();
        this.updateSliders();

    },

    updateSliders: function () {
        if (this.gridToSliderIsInit) {
            $.each(this.gridToSliderList, function( index, elmt ) {
                elmt.update();
            });
        }

        if (this.sliderNumbersList.length) {
            $.each(this.sliderNumbersList, function( index, elmt ) {
                elmt.update();
            });
        }
    },

    initSliders: function () {
        $('.js-bk-slider').each(function( index ) {
            var elmt = $( this ).find('.swiper-container');
            var swiper = new Swiper(elmt, {
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },

                pagination: {
                    el: '.swiper-pagination',
                },
            });
        });
    },

    sliderHeading: function() {
        var $slider = $('.bk-heading.-slider .slider');
        $slider.slick({
            infinite: true,
            dots: true,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 3000,
            pauseOnHover: false
        });

        $('.bk-heading.-slider .slick-controls .pause').on('click', function() {
            $slider.slick('slickPause');
        });

        $('.bk-heading.-slider .slick-controls .play').on('click', function() {
            $slider.slick('slickPlay');
        });
    },

    sliderWysiwyg : function() {
        var swiperWysiwyg = new Swiper('.swiper-wysiwyg', {
            direction: 'horizontal',
            loop: false,
            autoplay: false,
            lazy: true,
            autoHeight: false,
            watchOverflow: true,
            pagination: {
                el: '.swiper-pagination',
                type: 'fraction'
            },
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            on: {
                init: _.bind(function (swiper) {
                    this.sliderWysiwygProgressbar(swiper.$el, swiper.activeIndex);
                }, this),
                slideChange: _.bind(function (swiper) {
                    this.sliderWysiwygProgressbar(swiper.$el, swiper.activeIndex);
                }, this),
            },
        });
    },

    sliderWysiwygProgressbar : function($el, activeIndex) {
        var $progressbar = $el.find('.progressbar');
        var nbSlide = $el.find('.swiper-wrapper .swiper-slide:not(.swiper-slide-duplicate)').length;
        activeIndex = activeIndex + 1;
        $progressbar.css('width', (activeIndex/nbSlide*100)+'%');
    },

    sliderTimeline : function() {
        $('.js-swiper-timeline').each(_.bind(function (index, elem) {
            var swiperTimeline = new Swiper($(elem)[0], {
                direction: 'horizontal',
                loop: false,
                autoplay: false,
                slidesPerView: 1,
                slidesPerGroup: 1,
                spaceBetween: 60,
                watchOverflow: true,
                pagination: {
                    el: '.swiper-progressbar',
                    type: 'progressbar'
                },
                breakpoints: {
                    768: {
                        slidesPerView: 2,
                        slidesPerGroup: 2,
                    },
                    1024: {
                        slidesPerView: 3,
                        slidesPerGroup: 3,
                    }
                },
                navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
                },
                on: {
                    init: _.bind(function (swiper) {
                        this.sliderWysiwygProgressbar(swiper.$el, swiper.activeIndex);
                    }, this),
                    slideChange: _.bind(function (swiper) {
                        this.sliderWysiwygProgressbar(swiper.$el, swiper.activeIndex);
                    }, this),
                },
            });
        }, this));
    },

    sliderPersonalities : function() {
        $('.js-swiper-personalities').each(function (index, elem) {
            var swiperPersonalities = new Swiper($(elem)[0], {
                direction: 'horizontal',
                loop: false,
                autoplay: false,
                slidesPerView: 2,
                slidesPerGroup: 2,
                spaceBetween: 15,
                watchOverflow: true,
                pagination: {
                    el: $(elem).find('.swiper-pagination')[0],
                },
                breakpoints: {
                    600: {
                        slidesPerView: 3,
                        slidesPerGroup: 3,
                    },
                    768: {
                        slidesPerView: 4,
                        slidesPerGroup: 4,
                    },
                    1024: {
                        slidesPerView: 6,
                        slidesPerGroup: 6,
                    }
                }
            });

            // Update the slider when the accordion is open
            $(elem).closest('.bk-accordion').find('.js-accordion').on('click', function() {
                if (!$(this).hasClass('open')) {
                    setTimeout(function() {
                        swiperPersonalities.update();
                    }, 100);
                }
            })
        });
    },

    initGridToSlider : function () {
        $('.js-grid-to-slider').each(_.bind(function (index, elem) {
            var gridSlider = new Swiper($(elem).find('.swiper-container')[0], {
                slidesPerView: 1,
                spaceBetween: 15,
                slideToClickedSlide: false,
                centeredSlides: true,
                watchOverflow: true,
                pagination: {
                    el: $(elem).find('.swiper-pagination')[0],
                },

                on: {
                    init: function () {
                        $(elem).find('.swiper-slide-active').addClass('bigger').addClass('-transition');
                        window.bLazy.load($(elem).find('.lazy'));
                    },
                    slideChange: function () {
                        $(gridSlider.slides[gridSlider.previousIndex]).removeClass('bigger').removeClass('-transition');
                        $(gridSlider.slides[gridSlider.activeIndex]).addClass('bigger').addClass('-transition');
                    },
                    resize: function () {
                        $.fn.matchHeight._apply($(elem).find('.bk-actu'));
                        window.bLazy.load($(elem).find('.lazy'));
                    }
                }
            });

            this.gridToSliderList.push(gridSlider);
        }, this));
    },

    initOrDestroyGridToSlider : function () {
        if($('.js-grid-to-slider').length) {
            if ($(window).width() < 1024) {
                if (!this.gridToSliderIsInit) {
                    this.initGridToSlider();
                    this.gridToSliderIsInit = true;

                }
            } else {
                if (this.gridToSliderIsInit) {
                    $.each(this.gridToSliderList, function( index, elmt ) {
                        elmt.destroy();
                    });
                    this.gridToSliderList = [];
                    this.gridToSliderIsInit = false;
                }
            }

            $('.js-grid-to-slider').attr('data-init-swiper', String(this.gridToSliderIsInit));
        }
    },

    initSliderNumbers : function () {
        $('.js-slider-numbers').each(_.bind(function (index, elem) {
            var sliderNumbers = new Swiper($(elem).find('.swiper-container')[0], {
                direction: 'horizontal',
                loop: true,
                autoplay: false,
                arrows: true,
                dots: true,
                slidesPerView: 1,
                slideToClickedSlide: false,
                watchOverflow: true,
                navigation: {
                    nextEl: $(elem).find('.swiper-button-next')[0],
                    prevEl: $(elem).find('.swiper-button-prev')[0],
                },
                pagination: {
                    el: $(elem).find('.swiper-pagination')[0],
                },
            });

            this.sliderNumbersList.push(sliderNumbers);
        }, this));
    },

    sliderDocs : function () {
        $('.swiper-documents').each(_.bind(function (index, elem) {
            var sliderDocs = new Swiper($(elem).find('.swiper-container')[0], {
                direction: 'horizontal',
                loop: false,
                autoplay: false,
                arrows: true,
                dots: true,
                slidesPerView: 1,
                slidesPerGroup: 1,
                spaceBetween: 16,
                slideToClickedSlide: false,
                watchOverflow: true,
                navigation: {
                    nextEl: $(elem).find('.swiper-button-next')[0],
                    prevEl: $(elem).find('.swiper-button-prev')[0],
                },
                pagination: {
                    el: $(elem).find('.swiper-progressbar')[0],
                    type: 'progressbar'
                },
                breakpoints: {
                    600: {
                        slidesPerView: 2,
                        slidesPerGroup: 2,
                    },
                    1024: {
                        slidesPerView: 4,
                        slidesPerGroup: 4,
                    }
                },
                on: {
                    afterInit: _.bind(function (swiper) {
                        this.sliderWysiwygProgressbar(swiper.$el, swiper.activeIndex);

                        setTimeout(function(){
                            $('.bk-publi').matchHeight();
                        }, 100);
                    }, this),
                    slideChange: _.bind(function (swiper) {
                        this.sliderWysiwygProgressbar(swiper.$el, swiper.activeIndex);
                    }, this),
                }
            });
        }, this));
    },

    initOrDestroySliderNumbers : function () {
        if($('.js-slider-numbers').length) {
            if ($(window).width() < 1024) {
                if (!this.sliderNumbersIsInit) {
                    this.initSliderNumbers();
                    this.sliderNumbersIsInit = true;

                }
            } else {
                if (this.sliderNumbersIsInit) {
                    $.each(this.sliderNumbersList, function( index, elmt ) {
                        elmt.destroy();
                    });
                    this.sliderNumbersList = [];
                    this.sliderNumbersIsInit = false;
                }
            }

            $('.js-slider-numbers').attr('data-init-swiper', String(this.sliderNumbersIsInit));
        }
    },
});
